<template>
		<div class="content" style="background-size: cover;" v-if="!notFound">
      <Header></Header>
      <div class="nav">
      	<span class="">{{$t('winnerList')}}</span>
      </div>
      <div class="tab" style="margin-bottom: 20px">
        <span class="tab-li" @click="tabClick('draw')" :class="{'active':activeTab=='draw'}">{{ $t('lucky_draw') }}</span>
        <span class="tab-li" @click="tabClick('week')" :class="{'active':activeTab=='week'}">{{ $t('week_list') }}</span>
        <span class="tab-li" @click="tabClick('month')" :class="{'active':activeTab=='month'}">{{ $t('month_list') }}</span>
        <span class="tab-li" @click="tabClick('year')" :class="{'active':activeTab=='year'}">{{ $t('yearly_list') }}</span>
      </div>
      <div class=" personal-info" style="height: 1290px;">
        <div class="myPoints-list">
          <div class="point-history mt20">
            <div v-if=" activeTab =='draw' || activeTab =='week' || activeTab =='month' ">
              <div class="point-head ac disflex">
                <span class="point-one1">{{$t('Date')}}</span>
                <span class="point-one2">{{$t('phone')}}</span>
                <span class="point-one1 fs22">{{$t('Prize')}}</span>
              </div>
              <div style="height: 880px;overflow-y: scroll;">
                <div class="point-c app-en" v-for="(item,index) in list">
                  <div class="point-li ac disflex">
                    <span class="point-one1">{{item.date}}</span>
                    <span class="point-one2">{{item.mobile}}</span>
                    <span class="point-one1 fs22">{{item.prize_name}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="point-head ac disflex">
                <span class="point-one1">{{$t('avatar')}}</span>
                <span class="point-one2">{{$t('phone')}}</span>
                <span class="point-one1 fs22">{{$t('Stars')}}</span>
              </div>
              <div style="height: 880px;overflow-y: scroll;">
                <div class="point-c app-en" v-for="(item,index) in list">
                  <div class="point-li ac disflex">
                    <img style="width: 90px;height: 90px" class="at1" :src="item.avatar">
                    <span class="point-one2">{{item.mobile}}</span>
                    <div class="total_score fs26">
                      <img src="../../static/images/xing.png">{{item.total_score}}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="more mt50 ac crfff" v-if="isShow" ><button  @click="getMore" class="btn1">{{noMore}}</button></div>
          <div class="more mt50 ac crfff"  v-else ><button @click="getMore" class="btn1">{{$t('noMore')}}</button></div>
        </div>
      </div>
		</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {

    return {
			notFound:false,
			list:[],
			page:1,
			limit:5,
      score:'',
			isShow:true,
      listMenu:['All','action','adventure','puzzle','sports'],
      noMore:'',
      activeTab:'draw'
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
	},
    methods: {
		back(){
			this.$router.push({path:'/'})
		},

    tabClick(index){
      this.activeTab = index;
      this.page = 1;
      this.list = [];
      this.getHome()
    },

		getHome(){
			let that =this;
      this.$parent.loadModal(true);
			let data = {
				page:that.page,
        type:that.activeTab,
				//limit:that.limit,
			}
      this.noMore = that.$t('showMore')
			that.$api.post('/api/index/rank',data,r =>{
				that.$parent.returnCode(r,function(){
					that.$parent.loadModal(false);
					if(r.data.length>0){
						that.list = that.list.concat(r.data)
					}else{
						that.isShow = false;
            //that.noMore = that.$t('noMore')
						that.$utils.alertText(that.$t('noMore'));
					}

       });

			})
		},
		getMore(){
			let that = this;
			if(that.isShow){
				that.page++;
				that.getHome();
			}else{
				that.$utils.alertText(that.$t('noMore'));
			}
		},
	}
}
</script>
<style>
.at1{border: 4px solid #fdf790;border-radius: 100%;}
.total_score{background: #0032a6;border:3px solid #fff;color: #fff;display: block;padding: 10px 0;border-radius: 40px;min-width: 200px;text-align: center;}
</style>



// WEBPACK FOOTER //
// src/page/winnerList.vue